import type { AiChatBotDebugLevel } from './types'

const STORAGE_KEY = 'aiDebug'
const VALID_LEVELS: AiChatBotDebugLevel[] = ['verbose', 'console']

export function initAiDebugLevel(): void {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const param = params.get(STORAGE_KEY) as AiChatBotDebugLevel | null
  if (!param || !VALID_LEVELS.includes(param)) return
  try {
    sessionStorage.setItem(STORAGE_KEY, param)
  } catch {
    // Safari private mode / sandboxed iframe — skip persistence
    return
  }
  params.delete(STORAGE_KEY)
  const search = params.toString()
  history.replaceState(
    null,
    '',
    `${window.location.pathname}${search ? `?${search}` : ''}`,
  )
}

export function getAiDebugLevel(): AiChatBotDebugLevel | null {
  if (typeof window === 'undefined') return null
  try {
    const stored = sessionStorage.getItem(
      STORAGE_KEY,
    ) as AiChatBotDebugLevel | null
    return stored && VALID_LEVELS.includes(stored) ? stored : null
  } catch {
    return null
  }
}
